


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getOrderDetailPage } from '@/api/order'

@Component({
  name: 'TabChange'
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics: any
  @Prop({ default: '' }) defaultActivity: any
  private activeIndex: number = 0

  created() {
    this.activeIndex = Number(this.defaultActivity) || 0
  }

  @Watch('defaultActivity')
  private onChange(val) {
    this.activeIndex = Number(val)
  }

  get changedOrderList() {
    return [
      {
        label: '全部订单',
        value: 0,
        num: this.orderStatics.allOrders || 0
      },
      {
        label: '待付款',
        value: 1,
        num: this.orderStatics.pendingPaymentOrders || 0
      },
      {
        label: '待接单',
        value: 2,
        num: this.orderStatics.toBeConfirmed || 0
      },
      {
        label: '服务中',
        value: 3,
        num: this.orderStatics.deliveryInProgress || 0
      },
      {
        label: '待结单',
        value: 4,
        num: this.orderStatics.confirmed || 0
      },
      {
        label: '已完成',
        value: 5,
        num: this.orderStatics.completedOrders || 0
      },
      {
        label: '售后中',
        value: 6,
        num: this.orderStatics.cancelledOrders || 0
      },
      {
        label: '充值订单',
        value: 7,
        num: this.orderStatics.rechargeOrders || 0
      },
      {
        label: '抽奖订单',
        value: 8,
        num: this.orderStatics.drawOrders || 0
      },
      {
        label: '打赏订单',
        value: 9,
        num: this.orderStatics.tipOrders || 0
      }
    ]
  }

  private tabChange(activeIndex) {
    this.activeIndex = activeIndex
    this.$emit('tabChange', activeIndex)
  }
}
